import { useEffect, useState } from "react";
import { BUTTON_CONNECT_GOOGLE_DRIVE } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp, useSelectorApp } from "../../lib/redux";
import { createPortal } from "react-dom";
import BackDropLoader from "../Loaders/BackDropLoader";
import IconButton from "./IconButton";
import Loader from "../Loaders/Loader";
import AddIcon from "@mui/icons-material/Add";
import AddToDriveIcon from "@mui/icons-material/AddToDrive";
import {
  startConnectGoogleDrive,
  startGetTokenGoogleDrive,
} from "../../actions/user";
import Button from "./Button";

const ButtonGoogleDriveAction = ({
  id = "button-google-drive-action",
  text = BUTTON_CONNECT_GOOGLE_DRIVE,
  disabled = false,
  prevBlockClick = false,
  onPrevBlockClick = () => {},
  onClick = () => {},
  onCallbackOpenPopup = () => {},
  sx = {},
  showLogo = true,
  type = "button",
  mode = "verify",
  icon = <AddIcon />,
  disableRipple = false,
  showButtonIcon = false,
  doTranslation = true,
  children,
  variant,
  color,
  startIcon,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [externalPopup, setExternalPopup] = useState(null);

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const integrations = useSelectorApp((state) => state?.user?.integrations);
  const googleDriveIntegrations = integrations?.googleDrive || {};
  const isGoogleDriveConnected = Object.values(googleDriveIntegrations).some(
    (integration) => integration.isActive
  );

  const onConnectAccount = async () => {
    // Para Google Drive, no mostrar la alerta de progreso (no aplica)
    // Iniciar directamente el proceso de conexión
    dispatch(
      startConnectGoogleDrive({
        onChangeLoading: (loading) => {
          setIsLoading(loading);
          if (!loading) {
            onCallbackOpenPopup();
          }
        },
        onChangePopupReference: (popup) => setExternalPopup(popup),
      })
    );
  };

  const onGetTokenGoogleDrive = async ({ authCode, state }) => {
    setOpenBackDrop(true);
    const response = await dispatch(
      startGetTokenGoogleDrive({ authCode, state, withAuth: true })
    );
    setOpenBackDrop(false);

    if (response.ok) {
      await onClick();
    }
  };

  useEffect(() => {
    if (!externalPopup) {
      return;
    }

    const timer = setInterval(() => {
      if (!externalPopup) {
        timer && clearInterval(timer);
        return;
      }
      const currentUrl = externalPopup.location.href;
      if (!currentUrl) {
        return;
      }
      const searchParams = new URL(currentUrl).searchParams;
      const authCode = searchParams.get("code");
      const state = searchParams.get("state");

      if (authCode && state) {
        externalPopup.close();
        setExternalPopup(null);
        clearInterval(timer);

        onGetTokenGoogleDrive({
          authCode,
          state,
        });
      }
    }, 500);

    return () => {
      timer && clearInterval(timer);
    };
    // eslint-disable-next-line
  }, [externalPopup]);

  if (type === "icon") {
    return (
      <>
        {openBackDrop &&
          createPortal(
            <BackDropLoader open={openBackDrop} platform="googleDrive" />,
            document.body
          )}
        <IconButton
          id={id}
          disableRipple={disableRipple}
          sx={{ ...sx }}
          onClick={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (prevBlockClick) {
              onPrevBlockClick();
              return;
            }

            if (
              (!isGoogleDriveConnected && mode === "verify") ||
              mode === "add"
            ) {
              await onConnectAccount();
              return;
            }

            setIsLoading(true);
            onClick();
            setIsLoading(false);
          }}
        >
          {isLoading ? <Loader hasMarginTop={false} size={20} /> : icon}
        </IconButton>
      </>
    );
  }
  return (
    <>
      {openBackDrop &&
        createPortal(
          <BackDropLoader open={openBackDrop} platform="googleDrive" />,
          document.body
        )}
      <Button
        id={id}
        disabled={disabled}
        loading={isLoading}
        color={color || "secondary"}
        variant={variant}
        startIcon={startIcon ?? (showLogo ? <AddToDriveIcon /> : undefined)}
        sx={{
          ...sx,
        }}
        onClick={async (e) => {
          e.preventDefault();
          if (prevBlockClick) {
            onPrevBlockClick();
            return;
          }

          if (
            (!isGoogleDriveConnected && mode === "verify") ||
            mode === "add"
          ) {
            await onConnectAccount();
            return;
          }

          setIsLoading(true);
          await onClick();
          setIsLoading(false);
        }}
      >
        {children || (
          <>
            {showButtonIcon && icon}
            {doTranslation ? t(text) : text}
          </>
        )}
      </Button>
    </>
  );
};

export default ButtonGoogleDriveAction;
